import { useEffect, useRef } from 'react';

import { Checkbox } from '@flipster/react/design-system';
import segment, { ChartEvent } from '@flipster/utils/segment';

import { TvVisibleEventIndicatorStorageKey } from '../../misc/constants';
import { usePersistentToggle } from '../../misc/persistent';
import TradingView from '../../trading-view';
import { useTvHeaderContext } from '../index';

export const EventPlugin = () => {
  const tv = useTvHeaderContext();

  const helperRef = useRef<EventMarkerHelper>(null);

  const [checked, setChecked] = usePersistentToggle(TvVisibleEventIndicatorStorageKey);

  useEffect(() => {
    if (!helperRef.current) helperRef.current = new EventMarkerHelper(tv);
    return () => {
      helperRef.current?.clean();
    };
  }, [tv]);

  useEffect(() => {
    if (!checked) {
      helperRef.current?.clean();
      return;
    }
    helperRef.current?.draw();
  }, [checked]);

  return (
    <Checkbox
      checked={checked}
      onChange={(e) => {
        setChecked(e.currentTarget.checked);
        segment.track(ChartEvent.ChartEventToggleClick, {
          event_name: 'Event',
          action: e.currentTarget.checked ? 'turn_on' : 'turn_off',
        });
      }}
    >
      Event
    </Checkbox>
  );
};

class EventMarkerHelper {
  constructor(private readonly tv: TradingView) {}

  draw() {
    if (!this.tv.enabled) return;
    this.tv.activeChart?.refreshMarks();
  }

  clean() {
    if (!this.tv.enabled) return;
    this.tv.activeChart?.clearMarks(2);
  }
}
